import React, { useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, Brain, ShieldCheck, CreditCard, TrendingUp, Briefcase, Map } from 'lucide-react';
import { motion } from 'framer-motion';
const tomos = [{
  id: 1,
  icon: Brain,
  title: 'Reset Mental',
  subtitle: 'El Mapa de tu Dinero',
  color: 'bg-[#3B6B4F]'
}, {
  id: 2,
  icon: ShieldCheck,
  title: 'Blindaje Criollo',
  subtitle: 'Tu Plata en la Argentina Real',
  color: 'bg-[#1B3A5C]'
}, {
  id: 3,
  icon: CreditCard,
  title: 'Deuda Inteligente',
  subtitle: 'El Poder de la Deuda Inteligente',
  color: 'bg-[#8B2A2A]'
}, {
  id: 4,
  icon: TrendingUp,
  title: 'Inversiones Sin Miedo',
  subtitle: 'Tus Primeras Inversiones',
  color: 'bg-[#4A2C5C]'
}, {
  id: 5,
  icon: Briefcase,
  title: 'Ingresos Extra',
  subtitle: 'Libertad Laboral',
  color: 'bg-[#1F5C5C]'
}, {
  id: 6,
  icon: Map,
  title: 'La Ruta del Oro 2026',
  subtitle: 'Tu Centro de Mando',
  color: 'bg-gradient-to-br from-[#2A241B] to-[#1A1610]'
}];
export function TomosCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
    const gap = 24;
    const scrollAmount = cardWidth + gap;
    const newScroll = direction === 'left' ? scrollRef.current.scrollLeft - scrollAmount : scrollRef.current.scrollLeft + scrollAmount;
    scrollRef.current.scrollTo({
      left: newScroll,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
    const gap = 24;
    const index = Math.round(scrollRef.current.scrollLeft / (cardWidth + gap));
    setActiveIndex(Math.min(index, tomos.length - 1));
  };
  return <section className="bg-surface py-16 px-4 overflow-hidden border-b border-border" data-id="element-276">
      <div className="max-w-6xl mx-auto" data-id="element-277">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-ink text-center mb-10 font-serif" data-id="element-278">
          📚 Lo que vas a recibir{' '}
          <span className="text-primary block md:inline mt-2 md:mt-0 text-2xl md:text-3xl" data-id="element-279">
            (6 Tomos completos)
          </span>
        </motion.h2>

        <div className="relative" data-id="element-280">
          <button onClick={() => scroll('left')} className="hidden md:flex absolute -left-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white border border-border rounded-full items-center justify-center text-ink hover:bg-cream transition-colors shadow-md" aria-label="Anterior" data-id="element-281">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-282" />
          </button>
          <button onClick={() => scroll('right')} className="hidden md:flex absolute -right-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white border border-border rounded-full items-center justify-center text-ink hover:bg-cream transition-colors shadow-md" aria-label="Siguiente" data-id="element-283">
            <ChevronRightIcon className="w-6 h-6" data-id="element-284" />
          </button>

          <div ref={scrollRef} onScroll={handleScroll} className="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-8 pt-4 px-4 -mx-4 md:px-0 md:mx-0" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-285">
            {tomos.map((tomo, index) => <motion.div key={tomo.id} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} viewport={{
            once: true
          }} className="flex-shrink-0 snap-center w-[260px] md:w-[300px]" data-id="element-286">
                <div className={`rounded-lg border-2 border-gold/30 overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.15)] transition-transform hover:-translate-y-2 aspect-[3/4] flex flex-col relative ${tomo.color}`} data-id="element-287">
                  {/* Book spine effect */}
                  <div className="absolute left-0 top-0 bottom-0 w-6 bg-black/20 border-r border-white/10" data-id="element-288"></div>
                  <div className="absolute left-2 top-0 bottom-0 w-px bg-white/20" data-id="element-289"></div>

                  <div className="flex-1 flex flex-col items-center justify-center p-8 text-center relative z-10 ml-4" data-id="element-290">
                    <div className="w-16 h-16 rounded-full border-2 border-gold/50 flex items-center justify-center mb-6 bg-black/20" data-id="element-291">
                      <tomo.icon className="w-8 h-8 text-gold" data-id="element-292" />
                    </div>
                    <p className="text-gold/80 text-sm font-bold tracking-widest uppercase mb-2" data-id="element-293">
                      Tomo {tomo.id}
                    </p>
                    <h3 className="text-white text-2xl md:text-3xl font-bold leading-tight mb-3 font-serif drop-shadow-md" data-id="element-294">
                      {tomo.title}
                    </h3>
                    <p className="text-white/80 text-sm font-medium" data-id="element-295">
                      {tomo.subtitle}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-2" data-id="element-296">
          {tomos.map((_, index) => <button key={index} onClick={() => {
          if (!scrollRef.current) return;
          const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
          const gap = 24;
          scrollRef.current.scrollTo({
            left: index * (cardWidth + gap),
            behavior: 'smooth'
          });
        }} className={`h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-primary w-8' : 'bg-border hover:bg-primary/50 w-2.5'}`} aria-label={`Ir a tomo ${index + 1}`} data-id="element-297" />)}
        </div>

        <p className="text-center text-muted text-sm mt-4 md:hidden" data-id="element-298">
          Deslizá para ver todo 👉
        </p>
      </div>
    </section>;
}